import { Component, ViewChild, TemplateRef, Input, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { qmsService } from '../qms.service';
import { concatMap, from, of, tap } from 'rxjs';

@Component({
  selector: 'app-dv-participants',
  templateUrl: './dv-participants.component.html',
  styleUrls: ['./dv-participants.component.scss']
})
export class DvParticipantsComponent implements OnInit {

  isProcessing = true;
  private _searchValue: string = '';
  participantsGrid: any = [];
  qualityUsers: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  @Input() isDvDisabled: boolean;

  isFrozen: boolean = false;
  constructor(
    public dialog: MatDialog,
    public appService: AppService,
    public router: Router,
    public paginationService: PaginationService,
    public message: messageService,
    public qmsService: qmsService,
    private readonly snackBar: MatSnackBar) { }

  get searchValue(): string {
    return this._searchValue;
  }

  set searchValue(value: string) {
    this._searchValue = value;
    this.filterGrid();
  }

  ngOnInit() {
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDesignation();
    this.selectBoxForDepartment();

    this.appService.getQmsDvParticipantsVwDetailsByDvNo(this.qmsService.activityId).subscribe((data: any) => {
      this.participantsGrid = data;
      this.filteredParticipantsGrid = [...this.participantsGrid];
      this.isProcessing = false;
      this.isFrozen = !this.isDvDisabled;
    })
  }

  filterGrid() {
    const term = this.searchValue?.toString().toLowerCase().trim() || '';

    if (!term) {
      this.filteredParticipantsGrid = [...this.participantsGrid];
      return;
    }

    this.filteredParticipantsGrid = this.participantsGrid.filter((row: any) => {
      return (
        row.userName?.toLowerCase().includes(term) ||
        row.comments?.toLowerCase().includes(term) ||
        row.createdByUser?.toLowerCase().includes(term) ||
        (row.createdOn ? new Date(row.createdOn).toLocaleString().toLowerCase().includes(term) : false)
      );
    });
  }

  refreshGrid() {
    this.isProcessing = true;
    this.ngOnInit();
  }

  participants: any = {};
  operationFlag: string;
  popupTitle: string;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];

  selectBoxForDesignation() {
    this.designationCodeDropdown = [];
    this.designationCodeDropdown = this.dropDownForDesignationCode?.map((area: any) => ({
      valueExp: area.codelistCode,
      displayExp: area.codelistName
    })) || []
  }

  selectBoxForDepartment() {
    this.departmentCodeDropdown = [];
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((area: any) => ({
      valueExp: area.codelistCode,
      displayExp: area.codelistName
    })) || []
  }
  filteredParticipantsGrid: any[] = [];
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Investigation Person(s)";
    this.participants = {};
    this.investigationPersonArray = [];
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  searchUsersParentCheckBox: boolean = false;
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByEmailAddress: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  isSearchedPopupOpened: boolean = false;
  searchUserFunction() {
    this.isSearchedPopupOpened = true;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupTitle = "Search User";
    this.qualityUsers = [];
    this.tempArray = [...this.investigationPersonArray];
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }

  cancelSearchUserFunction() {
    if (this.operationFlag == 'ADD') {
      this.popupTitle = this.popupTitle == "Search User" ? "Create Investigation Persons" : "";
    } else {
      this.popupTitle = this.popupTitle == "Search User" ? "Update Investigation Persons" : "";
    }
    this.isSearchedPopupOpened = false;
    this.visibleSearchManagerPopup.close();
  }

  searchUsersGridDataFunction() {
    this.isProcessing = true;

    let searchOneQmsUserVwDetails = {
      userName: this.searchByUserName ? this.searchByUserName.toUpperCase() : '',
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByEmailAddress,
      designationCode: this.searchByDesignationCode ? this.searchByDesignationCode : '',
      departmentCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : '',
      module: "QMS" /* Note: module is mandatory in java query. Values can be assigned to module are 'QMS', 'TRN', 'DOCS'... and so on */
    };

    this.appService.getUsersDetailsFromOneQmsUsersWithRoles(searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.qualityUsers = response;
      this.qualityUsers.every((user: any) => {
        user.userChildCheckBox = false; return true;
      })
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  $source: string;
  $userName: string;
  onParentCheckBoxChanged(e: any) {
    if (this.isSearchedPopupOpened) {
      // Selection happening in the Search User popup (for ADD)
      this.$source = 'qualityUsers';
      this.$userName = 'userName'; // Source grid is qualityUsers, property is userName
    } else {
      // Selection happening in the Main grid (for DELETE)
      this.$source = 'participantsGrid';
      this.$userName = 'userName'; // Source grid is participantsGrid/filteredParticipantsGrid, property is userName
    }
    if (e.target.checked) {
      this.searchUserParentCheckBox = true;
      this.tempArray = [];
      this.onParentChecked();

    } else {
      this.searchUserParentCheckBox = false;
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    const dataArray = (this as any)[this.$source];
    const userNameKey = this.$userName;
    for (const user of dataArray) {
      user.userChildCheckBox = true;
      this.tempArray.push({ userId: user.userId, userName: user[userNameKey], participantId: user.dvParticipantId });
    }
  }

  onParentUnChecked() {
    const dataArray = (this as any)[this.$source];
    dataArray.every((user: any) => {
      user.userChildCheckBox = false; return true;
    })
    this.tempArray = [];
  }

  searchUserParentCheckBox: boolean = false;
  investigationPersonArray: any = [];
  tempArray: any = [];
  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (this.isSearchedPopupOpened) {
      // Selection happening in the Search User popup (for ADD)
      this.$source = 'qualityUsers';
      this.$userName = 'userName'; // Source grid is qualityUsers, property is userName
    } else {
      // Selection happening in the Main grid (for DELETE)
      this.$source = 'participantsGrid';
      this.$userName = 'userName'; // Source grid is participantsGrid/filteredParticipantsGrid, property is userName
    }

    if (e.target.checked) {
      childData.userChildCheckBox = true;
      if (this.operationFlag == 'EDIT') {
        this.qualityUsers.every((item: any) => { if (item.userChildCheckBox) { item.userChildCheckBox = false; } return true; })
        setTimeout(() => { childData.userChildCheckBox = true });
        this.tempArray.push({
          userId: childData.userId,
          userName: childData.userNameAtApplication
        })
        this.qualityUsers.every((item: any) => { if (item.userChildCheckBox) { item.userChildCheckBox = false; } return true; })
        setTimeout(() => { childData.userChildCheckBox = true });
        // Note: This specific line within EDIT might still use userNameAtApplication if that's the source for EDIT.
        // If consistency is needed for EDIT as well, change 'userNameAtApplication' to 'childData[this.$userName]' here too.
        this.tempArray.push({
          userId: childData.userId,
          userName: childData.userNameAtApplication // Consider changing to: childData[this.$userName] if consistency across all flows is desired
        })
      } else {
        this.onChildChecked(childData);
      }
    } else {
      childData.userChildCheckBox = this.searchUserParentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checkedUser: any) {
    if (!this.investigationPersonArray?.some((user: any) => user.userId === checkedUser.userId)) {
      this.tempArray.push({
        userId: checkedUser.userId,
        userName: checkedUser[this.$userName],
        participantId: checkedUser.dvParticipantId
      })
    }

    if ((this as any)[this.$source]?.every((user: any) => user.userChildCheckBox)) {
      this.searchUserParentCheckBox = true;
    }
  }

  onChildUnchecked(uncheckedUser: any) {
    const removal = this.tempArray?.findIndex((removableUser: any) => removableUser.userId == uncheckedUser.userId);
    if (removal > -1) this.tempArray?.splice(removal, 1);
  }

  resetSearchUsersGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.qualityUsers = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
    this.tempArray = [...this.investigationPersonArray];
  }

  addUserNameFunction() {
    this.investigationPersonArray = this.tempArray;
    this.participants.userName = this.investigationPersonArray.map((user: any) => user.userName).join(',');
    this.popupTitle = this.operationFlag == 'ADD' ? "Create User" : "Update User";
    this.isSearchedPopupOpened = false;
    this.visibleSearchManagerPopup.close();
  }

  editDvParticipantId: any;
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupTitle = "Update Investigation Persons";
    this.participants.userName = '';
    this.participants.comments = '';
    this.editDvParticipantId = editRowData.dvParticipantId;
    this.investigationPersonArray = [];
    this.appService.getDvParticipantByParticipantId(editRowData.dvParticipantId).subscribe((response: any) => {
      this.participants = response;
      let filteredQmsDvParticipantsDetails = this.participantsGrid.filter((x: any) => x.userId === response.userId);
      if (filteredQmsDvParticipantsDetails.length != 0) {
        this.participants.userName = filteredQmsDvParticipantsDetails[0].userName;
      }
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  create(participants: any) {
    if (!this.investigationPersonArray.length) {
      const message = {
        resultType: 'E', result: "Please choose the user"
      }
      this.snackbarMessage(message);
    } else if (this.investigationPersonArray.length == 1) {

      this.isProcessing = true;

      const obj = {
        dvNo: this.qmsService.activityId,
        userId: this.investigationPersonArray[0].userId,
        comments: participants.comments
      };

      this.appService.createQmsDvParticipant(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleAddAndEditPopup.close();
          }
          this.isProcessing = false;
          this.snackbarMessage(Response);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.createMultiple(participants);
    }
  }

  responses: any[] = []; /* To store the responses sequentially */
  createMultiple(participants: any) {
    this.isProcessing = true;
    this.responses = [];
    from(this.investigationPersonArray) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((participant: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */

          const obj = {
            dvNo: this.qmsService.activityId,
            userId: participant.userId,
            comments: participants.comments
          }

          /*  Call the API for the current setting */
          return this.appService.createQmsDvParticipant(obj).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = { participant, response: Response, };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(participant))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.tempArray = this.investigationPersonArray = [];
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  update(participants: any) {
    delete participants.createdOn;
    delete participants.updatedOn;

    this.isProcessing = true;

    const obj = {
      dvParticipantId: this.editDvParticipantId,
      dvNo: this.qmsService.activityId,
      userId: this.investigationPersonArray.length ? this.investigationPersonArray[0].userId : participants.userId,
      comments: participants.comments
    };

    this.appService.updateDvParticipant(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.ngOnInit();
          this.visibleAddAndEditPopup.close();
        }
        this.isProcessing = false;
        this.snackbarMessage(Response);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;

  resultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  cancelCopyResultPopup() {
    this.visibleResultPopup.close();
    this.refreshGrid();
  }

  snackbarMessage(Response: any) {
    let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      //duration: 5000,
      data: {
        message: Response.result,
        type: Response.resultType == 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok",
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteDvParticipantId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Investigation Persons";
    this.deleteDvParticipantId = deleteRowData.dvParticipantId;
    if (this.participants.deleteReason != undefined) {
      this.participants.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFunction(participant: any) {
    if (this.operationFlag == 'DELETE') {
      if (participant.deleteReason) {
        this.isProcessing = true;

        const data = {
          dvParticipantId: this.deleteDvParticipantId,
          deleteReason: participant.deleteReason,
        }

        this.appService.deleteQmsDvParticipant(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleDeletePopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
        field.style.color = 'red';
      }
    } else {
      this.deleteMultiple();
    }
  }

  deleteMultiple() {
    this.isProcessing = true;
    this.responses = [];
    from(this.tempArray)
      .pipe(
        concatMap((participant: any, index: number) => {

          const obj = {
            dvParticipantId: participant.participantId,
            deleteReason: this.participants.deleteReason,
          }
          return this.appService.deleteQmsDvParticipant(obj).pipe(
            tap((Response: any) => {
              this.responses[index] = { participant, response: Response, };
            }),
            concatMap(() => of(participant))

          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item);
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses);
          this.tempArray = this.investigationPersonArray = [];
          this.isProcessing = false;
          this.visibleDeletePopup.close();
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }


  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  designationSearchText: string = '';
  departmentSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  multiDelete() {
    this.operationFlag = 'MULTI_DELETE';
    this.popupTitle = "Delete Multiple Investigation Persons";
    this.participants.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

}
